import { createContext, useContext } from 'react';

export type MessageCategory = 'Transactional' | 'Marketing' | 'Engagement';

export type MessageContextData = {
	messageInstanceId?: string;
	messageTemplateId?: string;
	messageCategory?: MessageCategory;
	transactionAccountId?: string;
	analyticsDetails?: Record<string, string | number>;
	triggerId?: string;
	messageCreationType?: 'implicit' | 'explicit';
	product?: string;
	journeyId?: string;
	journeyTriggerId?: string;
};

const initialValue = {};

export const MessageContext = createContext<MessageContextData>(initialValue);

export const MessageContextProvider = MessageContext.Provider;

export const useMessageContext = () => useContext(MessageContext);
